var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import equal from 'fast-deep-equal';
import { MenuItem } from '@mui/material';
import { fieldValueIsSame, localeIsSame, disabledIsSame, } from '../../utils/formik';
import TextField from './TextField';
var SelectField = function (_a) {
    var items = _a.items, _b = _a.includeBlank, includeBlank = _b === void 0 ? false : _b, textFieldProps = __rest(_a, ["items", "includeBlank"]);
    return (React.createElement(TextField, __assign({ select: true }, textFieldProps),
        includeBlank && React.createElement(MenuItem, { value: "" }, "(blank)"),
        items.map(function (_a) {
            var text = _a.text, value = _a.value, disabled = _a.disabled;
            return (React.createElement(MenuItem, { key: value, value: value, disabled: disabled }, text));
        })));
};
export default SelectField;
var FormikSelectFieldUnmemoized = function (_a) {
    var _b = _a.formik, errors = _b.errors, handleBlur = _b.handleBlur, formikHandleChange = _b.handleChange, values = _b.values, items = _a.items, includeBlank = _a.includeBlank, selectFieldprops = __rest(_a, ["formik", "items", "includeBlank"]);
    var nameAsKey = selectFieldprops.name;
    var onChange = selectFieldprops.onChange;
    var handleChange = React.useCallback(function (event) {
        formikHandleChange(event);
        onChange && onChange(event);
    }, [onChange, formikHandleChange]);
    return (React.createElement(SelectField, __assign({ items: items, includeBlank: includeBlank, onBlur: handleBlur, onChange: handleChange, value: values[nameAsKey], error: Boolean(errors[nameAsKey]), helperText: errors[nameAsKey] }, selectFieldprops)));
};
var itemsAreSame = function (prevProps, nextProps) { return equal(prevProps.items, nextProps.items); };
export var FormikSelectField = React.memo(FormikSelectFieldUnmemoized, function (prevProps, nextProps) {
    return localeIsSame(prevProps, nextProps) &&
        fieldValueIsSame(prevProps, nextProps) &&
        itemsAreSame(prevProps, nextProps) &&
        disabledIsSame(prevProps, nextProps);
});
